import type { WithDeserializedData, WithId, ApiHostname, HostnameBase } from "Interfaces";

export type ApiUser = NonNullable<unknown> & User & WithDeserializedData;

export type User = {
	name: string;
	username: string;
	email: string;
	verified: boolean;
	role: Role;
} & WithId;

export type LoginUserResponse = {
	user: User;
	token: string;
	pusherKey: string;
	hostnameLimit: number;
};

export type LoginUserPayload = {
	email: string;
	password: string;
};

export type RegisterUserPayload = {
	macAddress: string;
	name: string;
	passwordConfirmation: string;
} & LoginUserPayload;

export type UpdateUserPayload = {
	username: string;
	email: string;
	name: string;
} & WithId;

export type UpdatePasswordPayload = {
	currentPassword: string;
	password: string;
	passwordConfirmation: string;
};

export type UpdateAccountPayload = {
	username: string;
	email: string;
	name: string;
};

export enum UserMeta {
	TOKEN = "token",
	PUSHER_KEY = "pusherKey",
	HOSTNAME_LIMIT = "hostnameLimit",
	ROLES = "role"
}

export type UserState = {
	pusherKey: string | null;
	token: string | null;
	user: User | null;
	hostnameLimit: number;
	users: UserResource[];
};

export type Role = "super-admin" | "admin" | "support" | "user";

export type UserResource = User & {
	hostnames: ApiHostname[];
};

export type CreateUserHostnamePayload = HostnameBase & {
	userId: string;
};
